// @flow
import React, { useEffect, useState, useMemo } from 'react'
import { View, Text, Picker, Switch } from 'react-native'
import { useTranslation } from 'react-i18next'

import {
  LunarDate,
  getSolarMonthDays,
  HOUR_SELECTION,
  Astrolabe as astrolabe,
  ASTROLABE_VERSION,
} from '../../../../api'
import Input from '../../../../components/Input'
import RadioButton from '../../../../components/RadioButton'
import Row from '../../../../components/Row'
import { useLocalPreference } from '../../../global'
import Astrolabe from '../../components/Astrolabe'
import { useAstrolabe } from '../../context'

type Props = {
  navigation: Object,
}
const TAModal = ({ navigation, isWideScreen }: Props) => {
  console.log('isWideScreen: ', isWideScreen)
  const { draftTA, setDraftTA } = useAstrolabe()
  // console.log('draftTA: ', draftTA)
  const { t } = useTranslation()
  const { theme } = useLocalPreference()
  const { palette } = theme
  const now = draftTA
    ? LunarDate.ToWesternDate(
        draftTA.lunarDate.year,
        draftTA.lunarDate.month,
        draftTA.lunarDate.day,
        draftTA.lunarDate.hour,
        draftTA.lunarDate.isLeap,
      )
    : new Date()
  const [name, setName] = useState(draftTA ? draftTA.name : '')
  const [isMale, setIsMale] = useState(draftTA ? draftTA.isMale : 0)
  const [isLunarCalendar, setIsLunarCalendar] = useState(false)
  const [isLeap, setIsLeap] = useState(
    draftTA ? draftTA.lunarDate.isLeap : false,
  )
  const [selectedYear, setSelectedYear] = useState(now.getFullYear())
  const [selectedMonth, setSelectedMonth] = useState(now.getMonth() + 1)
  const [selectedDate, setSelectedDate] = useState(now.getDate())
  const [selectedHour, setSelectedHour] = useState(now.getHours())
  const [supportedYears, initSupportedYears] = useState([])
  const [datesOfMonth, setDatesOfMonth] = useState([])
  const [preview, setPreview] = useState()
  const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

  const lunarDate = useMemo(() => {
    let date = new Date(
      selectedYear,
      selectedMonth - 1,
      selectedDate,
      selectedHour,
    )
    if (isLunarCalendar) {
      date = LunarDate.ToWesternDate(
        selectedYear,
        selectedMonth,
        selectedDate,
        selectedHour,
        isLeap,
      )
    }
    console.log('isLeap: ', isLeap, date)
    return new LunarDate(date)
  }, [
    isLunarCalendar,
    isLeap,
    selectedYear,
    selectedMonth,
    selectedDate,
    selectedHour,
  ])

  useEffect(() => {
    const years = []
    for (let i = 1900; i < 2100; i++) {
      years.push(i)
    }
    initSupportedYears(years)
  }, [])

  useEffect(() => {
    console.log('selectdMonth:', selectedMonth)
    const days = getSolarMonthDays(selectedYear, selectedMonth)
    const dates = []
    for (let i = 1; i <= days; i++) {
      dates.push(i)
    }
    setDatesOfMonth(dates)
  }, [selectedYear, selectedMonth])

  useEffect(() => {
    let tempTA = {
      name,
      lunarDate,
      isMale,
    }
    if (draftTA && draftTA.id) {
      tempTA.id = draftTA.id
    }
    // console.log('lunarDate to save: ', lunarDate, tempTA)
    setDraftTA(tempTA)
  }, [name, lunarDate, isMale])

  useEffect(() => {
    setPreview(new astrolabe(lunarDate, isMale, ASTROLABE_VERSION.PREVIEW))
  }, [lunarDate, isMale])

  return (
    <View style={{ flex: 1, paddingVertical: 16, paddingHorizontal: 16, backgroundColor: palette.background.default, flexDirection: isWideScreen ? 'row' : 'column' }}>
      <View style={{ flex: isWideScreen ? 3 : 1 }}>
        <Input
          placeholder={t('name_nickname')}
          value={name}
          onChange={text => setName(text)}
          style={{ marginBottom: 8, borderRadius: 2, borderColor: palette.border, height: 44 }}
        />
        <RadioButton
          theme={theme}
          options={[
            { label: t('female'), value: 0, activeColor: palette.self },
            { label: t('male'), value: 1, activeColor: palette.auxStar },
          ]}
          onChange={val => setIsMale(val)}
          value={isMale}
        />
        <Text style={{ marginTop: 16, marginBottom: 4, color: palette.text.primary }}>{t('birth_time')}</Text>
        <Row alignHorizontal="space-between">
          <RadioButton
            theme={theme}
            options={[
              { label: t('solar_calendar'), value: 0 },
              { label: t('lunar_calendar'), value: 1 },
            ]}
            onChange={val => setIsLunarCalendar(val === 1)}
          />
          {isLunarCalendar && (
            <Row width="auto">
              <Text style={{ marginRight: 4 }}>{t('is_leap')}</Text>
              <Switch value={isLeap} onValueChange={val => setIsLeap(val)} />
            </Row>
          )}
        </Row>
        <Row style={{ marginTop: 16, marginBottom: 4 }}>
          <Picker
            style={{ flexBasis: '20%', paddingVertical: 8, paddingHorizontal: 4, borderColor: palette.border, color: palette.text.default }}
            selectedValue={selectedYear}
            onValueChange={val => setSelectedYear(val)}>
            {supportedYears.map(y => (
              <Picker.Item key={'year-' + y} label={String(y)} value={y} />
            ))}
          </Picker>
          <Picker
            style={{ flexBasis: '12%', paddingVertical: 8, paddingHorizontal: 4, borderColor: palette.border, color: palette.text.default }}
            selectedValue={selectedMonth}
            onValueChange={val => setSelectedMonth(val)}>
            {months.map(m => (
              <Picker.Item key={'month-' + m} label={String(m)} value={m} />
            ))}
          </Picker>
          <Picker
            style={{ flexBasis: '12%', paddingVertical: 8, paddingHorizontal: 4, borderColor: palette.border, color: palette.text.default }}
            selectedValue={selectedDate}
            onValueChange={val => setSelectedDate(val)}>
            {datesOfMonth.map(d => (
              <Picker.Item key={'date-' + d} label={String(d)} value={d} />
            ))}
          </Picker>
          <Picker
            style={{ flexBasis: '56%', paddingVertical: 8, paddingHorizontal: 4, borderColor: palette.border, color: palette.text.default }}
            selectedValue={selectedHour}
            onValueChange={val => setSelectedHour(val)}>
            {HOUR_SELECTION.map((h, i) => (
              <Picker.Item key={'hour-' + i} label={t(h.label)} value={h.value} />
            ))}
          </Picker>
        </Row>
        <Text style={{ marginBottom: 16, color: palette.text.comment }}>
          {isLunarCalendar
            ? lunarDate.toWesternDate().toLocaleString()
            : lunarDate.toString(t)}
        </Text>
      </View>
      <View style={isWideScreen ? { flex: 2, marginLeft: 12 } : { flex: 1, marginTop: 16 }}>
        <Astrolabe
          theme={theme}
          astrolabe={preview}
          version={ASTROLABE_VERSION.PREVIEW}
        />
      </View>
    </View>
  )
}
export default TAModal
